function initializeAnimationElements(rootElement = document) {
    function splitWordsAndAnimate(animationTextElement, animationClassName) {
        const wordWrappers = [];
        animationTextElement.forEach((animationElement) => {
            const innerText = animationElement.innerText;
            animationElement.ariaLabel = innerText;
            const words = innerText.split(' ');
            animationElement.innerHTML = '';
            words.forEach((word) => {
                const wordElement = document.createElement('span');
                wordElement.textContent = word;
                const wordWrapper = document.createElement('span');
                wordWrapper.appendChild(wordElement);
                wordWrapper.classList.add('mask-in-animation');
                if (animationClassName) {
                    wordWrapper.classList.add(animationClassName);
                }
                wordWrapper.ariaHidden = true;
                animationElement.appendChild(wordWrapper);
                animationElement.innerHTML += ' ';
                wordWrappers.push(wordWrapper);
            });
        });
        return wordWrappers;
    }

    function initializeOnScrollAnimations(animationElements) {
        splitWordsAndAnimate(animationElements, 'on-scroll');

        // Observe scrolling for on scroll animations

        const animatableIntersectionObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.children[0].classList.add('play');
                    observer.unobserve(entry.target);
                }
            });
        });
        // Note: It is required to requery the elements - otherwise the IntersectionObserver will not work properly.
        rootElement.querySelectorAll('.mask-in-animation.on-scroll').forEach((animatableElement) => {
            animatableIntersectionObserver.observe(animatableElement);
        });
    }

    function initializeQuoteAnimations(quoteListSelector) {
        const quoteListElements = rootElement.querySelectorAll(quoteListSelector);

        // Observe scrolling for on scroll animations

        const animatableIntersectionObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.querySelectorAll('.quote.active')[0].classList.add('interacted');
                    observer.unobserve(entry.target);
                }
            });
        });

        quoteListElements.forEach((quoteListElement) => {
            splitWordsAndAnimate(quoteListElement.querySelectorAll('.quote blockquote'), '');
            animatableIntersectionObserver.observe(quoteListElement);
        });
    }

    function initializeInstantAnimations(animationElements) {
        splitWordsAndAnimate(animationElements, '');
    }

    // Split words and add animations...
    const scrollAnimationSelectors = [
        '.banner-text',
        '.trend-header-heading',
        '.introduction-header',
        '.cta-banner-heading',
        '.text-banner:not(.highlight) .text-banner-heading',
       '.graph-banner-heading',
    ];
    const scrollAnimationElements = rootElement.querySelectorAll(scrollAnimationSelectors.join(', '));
    initializeOnScrollAnimations(scrollAnimationElements);
    initializeQuoteAnimations('.quotes');
    const instantAnimationSelectors = [
        '.hero-carousel .title-container-main-title',
        '.hero-carousel .card .card-title',
    ];
    const instantAnimationElements = rootElement.querySelectorAll(instantAnimationSelectors.join(', '));
    initializeInstantAnimations(instantAnimationElements);
}

addEventListener('load', () => {
    initializeAnimationElements();
    document.addEventListener('overlay-created', (event) => {
        const overlayContainer = event.detail.overlayContainer;
        initializeAnimationElements(overlayContainer);
    });
});
